module.exports = __webpack_public_path__ + "static/media/vip-access-store-tile-2-promo.c84effdd.png";